import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FAQ = () => {
  const faqs = [
    {
      question: "What makes Elyte Fitness different from other fitness programs?",
      answer: "Elyte Fitness stands out through our science-based approach, personalized training plans, and comprehensive support system. We combine expert coaching with cutting-edge technology to ensure sustainable results. Our programs are tailored to individual needs, and we provide ongoing accountability and support to help you achieve your goals."
    },
    {
      question: "How do I get started with Elyte Fitness?",
      answer: "Getting started is easy! Simply choose a membership plan that suits your needs, and you'll receive immediate access to your personalized training program. We'll guide you through the initial setup process, including your fitness assessment and goal setting. You can start with a free trial to experience our program firsthand."
    },
    {
      question: "What kind of support can I expect?",
      answer: "Our support system includes regular check-ins, text support for quick questions, and comprehensive coaching. Depending on your membership level, you'll have access to nutrition guidance, accountability coaching, and virtual consultations. We're committed to being there every step of your fitness journey."
    },
    {
      question: "Do I need any special equipment?",
      answer: "Our programs are designed to be flexible and adaptable. While some workouts may include equipment, we provide alternatives for those who don't have access to a full gym. We can modify exercises based on the equipment you have available, ensuring you can complete your workouts effectively."
    },
    {
      question: "How often should I work out?",
      answer: "The frequency of your workouts depends on your goals, current fitness level, and schedule. Our programs are designed to be flexible, typically ranging from 2-6 days per week. We'll help you find the right balance that works for your lifestyle while ensuring optimal results."
    },
    {
      question: "What if I have an injury or health condition?",
      answer: "Safety is our top priority. We conduct thorough assessments and can modify programs to accommodate injuries or health conditions. Our team includes professionals with experience in rehabilitation and adaptive fitness. We'll work with you to create a safe and effective program that considers your specific needs."
    },
    {
      question: "Can I change my membership plan later?",
      answer: "Yes, you can upgrade or modify your membership plan at any time. We understand that your needs may change, and we're here to support your journey. Contact our support team to discuss your options and find the best plan for your current goals."
    },
    {
      question: "What results can I expect?",
      answer: "Results vary based on individual factors, including consistency, effort, and starting point. However, our clients typically see noticeable improvements in strength, endurance, and overall fitness within 4-8 weeks. We focus on sustainable progress and long-term success rather than quick fixes."
    }
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4">
            <h1 className="text-4xl font-bold text-center mb-12">
              Frequently Asked <span className="text-sky-600">Questions</span>
            </h1>
            
            <div className="space-y-8">
              {faqs.map((faq, index) => (
                <div 
                  key={index}
                  className="bg-gray-50 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
                >
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {faq.question}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-12 text-center">
              <p className="text-gray-600 mb-4">
                Still have questions? We're here to help!
              </p>
              <a
                href="#contact"
                className="inline-block bg-sky-600 text-white px-8 py-3 rounded-xl hover:bg-sky-700 transition"
              >
                Contact Us
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default FAQ; 